<template>

    <div class="y-practice is_schedule">


        <div class="y-practice__content">


            <div class="y-practice__row sticky-top" style="--sticky_top: 3px">
                <div class="y-practice__datetime" data-datetime>
                    <div class="y-practice__datetime-txt">{{ datetimeHeader }}</div>
                    <div class="y-practice__datetime-icn">
                        <svg
                            width="17" height="18" viewBox="0 0 17 18" style="fill:none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <rect
                                x="1" y="2.23096" width="14.7692" height="14.7692" rx="2" stroke="#1E1E20"
                                stroke-width="1.5"
                            />
                            <path d="M1 6.33311H15.7692" stroke="#1E1E20" stroke-width="1.5" stroke-linejoin="round" />
                            <path
                                d="M12.077 1L12.077 3.46154" stroke="#1E1E20" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                            <path
                                d="M4.69224 1L4.69224 3.46154" stroke="#1E1E20" stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                            <path
                                d="M3.87183 9.61513H4.69234" stroke="#1E1E20" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                            <path
                                d="M7.97437 9.61513H8.79488" stroke="#1E1E20" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                            <path
                                d="M12.0769 9.61513H12.8974" stroke="#1E1E20" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                            <path
                                d="M3.87183 12.8974H4.69234" stroke="#1E1E20" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                            <path
                                d="M7.97437 12.8974H8.79488" stroke="#1E1E20" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                            <path
                                d="M12.0769 12.8974H12.8974" stroke="#1E1E20" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                    </div>
                    <datetime
                        :value="on_date_c"
                        :config="datetimePickerConfig"
                        class="flatpickr y-practice__flatpickr"
                        placeholder="Select data"
                    />

                </div>
                <div class="y-practice__select">

                <multiselect
                    class="multiselect"
                    v-model="selectedGroup"
                    label="name"
                    track-by="id"
                    :options="groups"
                    :multiple="false"
                    open-direction="bottom"
                    @input="changeGroup"
                >
                    </multiselect>
        </div>
            </div>

            <div class="y-practice-table is_schedule y-practice__table">
                <div class="y-practice-table__th">
                    <div class="y-practice-table__td"></div>
                    <div v-for="day in days" class="y-practice-table__td">
                        <div class="y-practice-table__week-day">{{ day.week_day_name }}</div>
                        <div class="y-practice-table__day">{{ day.date.split('/')[0] }}</div>
                    </div>

                </div>

                <div v-for="(time, index) in data_table" class="y-practice-table__tr">

                    <div class="y-practice-table__td">
                        <div class="y-practice-table__time">{{ index }}</div>
                    </div>

                    <template v-for="group in time">
                        <div
                            class="y-practice-table__td"
                            :class="{ is_event: group.id }"
                            :style="{ 'background-color': group.color }"
                            :title="group.name"
                            :data-modal-init="group.id && modal_init ? 'events': null"
                            @click="group.id && eventClick(group, index)"
                        >
                            <span class="y-line-clamp-2">{{ group.name }}</span>
                        </div>
                        <!--<div
                                v-if="choose_data.some(item => item.day === date && item.start === index)"
                                @click="deletePeriod(date, index, item)"
                                class="y-practice-table__td is_chose"
                                :style="[ item.status !== 4 ? {'cursor': 'pointer'} : '', item.color !== '' ? { 'background-color': `var(&#45;&#45;practice_td_bgc, ${ item.color })` } : '']"
                                :title="item.status ? item.value : null "
                        ></div>

                        <div
                                v-else
                                @click="chosePeriod(date, index, item)"
                                :data-modal-init="item.status === 2 && AddClassChoose ? 'reserved' : null"
                                :class="[ 'y-practice-table__td', { 'is_free': item.status === 1 }]"
                                :style="[ item.status !== 4 ? {'cursor': 'pointer'} : '', item.color !== '' ? { 'background-color': `var(&#45;&#45;practice_td_bgc, ${ item.color })` } : '']"
                                :title="item.status ? item.value : null"
                        ></div>-->
                    </template>

                </div>


            </div>

        </div>


        <div
            class="y-modal is_events y-practice__modal-events"
            data-modal="events"
            v-if="show_modal_show_event"
        >
            <div class="y-modal__inner">
                <div class="y-modal__header">
                    <div class="y-modal__subtitle">
                        {{ dateFormatting(group.datetime) }} у {{ eventTime }}, на Вас очікує подія
                    </div>
                    <button
                        data-modal-close
                        class="y-btn is_events y-modal__btn-close"
                        aria-label="close modal events"
                    >
                        <span class="y-btn__icn"></span>
                        <span class="y-btn__txt">закрыть</span>
                    </button>
                    <div class="y-modal__title">{{ group.name }}</div>
                </div>
                <div class="y-modal__main" data-scroll-check>
                    <div class="y-modal__main-inner" data-scroll-inner>
                        <div class="y-editor" data-editor v-html="group.description"></div>
                    </div>
                </div>
                <div class="y-modal__footer">
                    <div class="elms jcfe cg-10">
                        <button
                            type="button"
                            data-modal-close
                            class="y-btn y-btn_default is_events y-record__btn-default"
                        >
                            <span class="y-btn__icn">{{ $t('Close') }}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>

    </div>


</template>


<script>
// import flatPickr from 'vue-flatpickr-component';
// import 'flatpickr/dist/flatpickr.css';
import axios from "axios";

export default {
    name: "StudentSchedule",
    props: [ 'all_days', 'table', 'select_date', 'groups', 'studentGroup' ],
    // components: { datetime: flatPickr },
    data() {
        return {
            show_modal_show_event: false,
            selectedGroup: null,
            group: null,
            on_date: null,
            data_table: null,
            days: null,
            data_schedule: null,
            datetimeHeader: '',
            eventTime: '',
            modal_init: false,
            datetimePickerConfig: {
                static: true,
                enableMonth: true,
                altFormat: "Y-m-d",
                dateFormat: "Y-m-d",
                locale: {
                    firstDayOfWeek: 1,
                    // weekdays: {
                    //  shorthand: [ 'Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa' ],
                    //  longhand: [ 'Вівторок', 'Середа', 'Четвер', "'П'ятниця'", 'Субота', 'Неділя', 'Понеділок' ],
                    // },
                    // months: {
                    //  shorthand: [ 'Jan', 'Feb', 'March', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec' ],
                    //  longhand: [ 'Січень', 'Лютий', 'Березень', 'Квітень', 'Травень', 'Червень', 'Липень', 'Серпень', 'Вересень', 'Жовтень', 'Листопад', 'Грудень' ],
                    // },
                },
                nextArrow: '<svg width="25" height="24" viewBox="0 0 25 24" style="fill:none" xmlns="http://www.w3.org/2000/svg"><path d="M16.5 16L19.7929 12.7071C20.1834 12.3166 20.1834 11.6834 19.7929 11.2929L16.5 8" stroke="#6A6A6A" stroke-width="1.5" stroke-linecap="round"/><path d="M19.5 12L5.5 12" stroke="#6A6A6A" stroke-width="1.5" stroke-linecap="round"/></svg>',
                prevArrow: '<svg width="24" height="24" viewBox="0 0 24 24" style="fill:none" xmlns="http://www.w3.org/2000/svg"><path d="M8 8L4.70711 11.2929C4.31658 11.6834 4.31658 12.3166 4.70711 12.7071L8 16" stroke="#6A6A6A" stroke-width="1.5" stroke-linecap="round"/><path d="M5 12L19 12" stroke="#6A6A6A" stroke-width="1.5" stroke-linecap="round"/></svg>',
                disable: [
                    function (date) {
                        return ([ 0, 2, 3, 4, 5, 6 ].includes(date.getDay()));
                    }
                ],
                onChange: (dateObj, dateStr) => {
                    this.getEvents(dateStr);
                },
            }
        }
    },
    computed: {
        on_date_c: {
            get: function () {
                return this.select_date
            },
            set: function (newValue) {
                return newValue;
            }
        }
    },
    async mounted() {
        if (!this.$parent.initedLocale) {
            this.$parent.initedLocale = true;
            const { data: { locale } } = await axios.get('/locale/language');
            this.$i18n.locale = locale || (process.env.MIX_APP_LOCALE !== undefined
                                           ? process.env.MIX_APP_LOCALE : 'ua')
            ;
        }
        this.selectedGroup = this.studentGroup
        this.datetimePickerConfig.locale.weekdays = {
            shorthand: [ this.$t('Su'), this.$t('Mo'), this.$t('Tu'), this.$t('We'), this.$t('Th'), this.$t('Fr'), this.$t('Sa') ],
            longhand: [ this.$t('Sunday'), this.$t('Monday'), this.$t('Tuesday'), this.$t('Wednesday'), this.$t('Thursday'), this.$t('Friday'), this.$t('Saturday') ],
        };

        this.datetimePickerConfig.locale.months = {
            shorthand: [ this.$t('Jan'), this.$t('Feb'), this.$t('March'), this.$t('Apr'), this.$t('May'), this.$t('June'), this.$t('July'), this.$t('Aug'), this.$t('Sept'), this.$t('Oct'), this.$t('Nov'), this.$t('Dec') ],
            longhand: [ this.$t('January'), this.$t('February'), this.$t('March'), this.$t('April'), this.$t('May'), this.$t('June'), this.$t('July'), this.$t('August'), this.$t('September'), this.$t('October'), this.$t('November'), this.$t('December') ],
        };

        this.data_table = this.table;
        this.days = this.all_days;

        this.days.forEach((day, index) => {
            if (index === 0) {
                const date = day.date.split("/").reverse().join("/")
                this.datetimeHeader = this.getDateWeek(date)
            }
        })

        $(document).on('click', '[data-modal-close].is_events', () => {
            $(`[data-modal]`).on('transitionend webkitTransitionEnd oTransitionEnd', () => {
                $('[data-overlay]').on('transitionend webkitTransitionEnd oTransitionEnd', () => {
                    this.group = null;
                    this.show_modal_show_event = false;
                    $(`[data-modal].is_events`).off('transitionend webkitTransitionEnd oTransitionEnd')
                })
            })
        })
    },
    methods: {
        dateFormatting(date) {
            const d = new Date(date)
            const monthArray = 'січня, лютого, березеня, квітня, травня, червня, липня, серпня, вересня, жовтня, листопада, грудня'
            const day = new Intl.DateTimeFormat('uk-UA', { day: 'numeric' }).format(d)
            const monthNum = new Intl.DateTimeFormat('uk-UA', { month: 'numeric' }).format(d)
            const month = monthArray.split(',')[monthNum - 1]
            return `${ day } ${ month }`
        },
        getDateWeek(day) {
            const currentWeek = day ? new Date(day) : new Date()
            const month = this.$t(new Intl.DateTimeFormat('en-US', { month: 'long' }).format(currentWeek))
            const startWeek = new Intl.DateTimeFormat('uk-UA', { day: 'numeric' }).format(currentWeek)
            const endWeek = new Intl.DateTimeFormat('uk-UA', { day: 'numeric' }).format(currentWeek.setDate(currentWeek.getDate() + 6))
            const year = new Intl.DateTimeFormat('uk-UA', { year: 'numeric' }).format(currentWeek)

            return `${ month[0].toUpperCase() + month.slice(1) } ${ startWeek < 10 ? 0 + startWeek : startWeek }-${ endWeek < 10 ? 0 + endWeek : endWeek }, ${ year }`

        },
        async getEvents(on_date) {
            const {
                data: {
                    all_days,
                    data_table,
                    select_date,
                    groups,
                    student_group,
                }
            } = await axios.get('/student/dashboard/event?on_date=' + on_date + '&group_id=' + this.selectedGroup.id);

            this.on_date_c = select_date;
            this.days = all_days;
            this.data_table = data_table;
            this.datetimeHeader = this.getDateWeek(on_date)
            this.groups = groups
            this.selectedGrouproup = student_group
        },

        async changeGroup() {
            const {
                data: {
                    all_days,
                    data_table,
                    select_date,
                    groups,
                    studentGroup,
                }
            } = await axios.get('/student/dashboard/event?group_id=' + this.selectedGroup.id);

            this.on_date_c = select_date;
            this.days = all_days;
            this.data_table = data_table;
            // this.datetimeHeader = this.getDateWeek(on_date)
            this.groups = groups
            this.selectedGroup = studentGroup
        },

        eventClick(group, time) {
            if (group.link) {
                if (this.isExternalLink(group.link)) {
                    window.open(group.link, '_blank').focus();
                } else {
                    location.href = group.link;
                }

            } else if (group.event_type_id === 3) {
                this.modal_init = true
                this.show_modal_show_event = true;
                this.group = group;
                this.eventTime = time
            }
        },
        isExternalLink(url) {
            const hostname = new URL(url).hostname;
            const currentHostname = window.location.hostname;
            return hostname !== currentHostname;
        },

        cancel() {
            this.group = null;
            this.show_modal_show_event = false;
        },
    }
}
</script>

<style>
.event-table td {
    cursor: auto;
    height: 45px
}

.event-table td.is_event {
    cursor: pointer;
}
</style>
